// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GitlabIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 380 380">
    <path
      fill="#e24329"
      d="m357.23 155.28-.48-1.25-47.09-122.9a12.3 12.3 0 0 0-4.85-5.83 12.37 12.37 0 0 0-18.59 7.11l-31.8 97.29H125.67l-31.8-97.29a12.4 12.4 0 0 0-4.18-6.36 12.6 12.6 0 0 0-14.41-.77 12.4 12.4 0 0 0-4.85 5.84L23.25 154l-.47 1.24a87.46 87.46 0 0 0 29 101.07l.16.13.43.3 71.74 53.72 35.49 26.86 21.62 16.33a14.55 14.55 0 0 0 17.58 0l21.62-16.33 35.49-26.86 72.17-54 .18-.15a87.46 87.46 0 0 0 28.97-101.03"
    />
    <path
      fill="#fc6d26"
      d="m357.23 155.28-.48-1.25a159 159 0 0 0-63.32 28.47L190 260.7c35.22 26.65 65.88 49.8 65.88 49.8l72.17-54.05.18-.14a87.5 87.5 0 0 0 29-101.03"
    />
    <path
      fill="#fca326"
      d="m124.12 310.5 35.49 26.86 21.62 16.32a14.55 14.55 0 0 0 17.58 0l21.62-16.32 35.49-26.86s-30.7-23.23-65.92-49.8c-35.22 26.57-65.88 49.8-65.88 49.8"
    />
    <path
      fill="#fc6d26"
      d="M86.56 182.5A159 159 0 0 0 23.25 154l-.47 1.24a87.46 87.46 0 0 0 29 101.07l.16.13.43.3 71.74 53.72L190 260.63Z"
    />
  </svg>,
  "Gitlab",
);
export default GitlabIcon;
